import { DialogHeader as ReactDialogHeader } from "@certn/cascadia-react/components/modal/DialogHeader";
import { memo } from "react";

import { CascadiaDialogHeaderProps } from "./types";

export const DialogHeader = memo(function (props: CascadiaDialogHeaderProps) {
  return <ReactDialogHeader {...props} />;
});
